import React from 'react';
import { motion } from 'framer-motion';
import './SearchFilter.css';

const SearchFilter = ({ 
    searchTerm, 
    setSearchTerm, 
    selectedGenre, 
    setSelectedGenre, 
    genres = []
}) => {
    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleGenreChange = (e) => {
        setSelectedGenre(e.target.value);
    };

    const clearFilters = () => {
        setSearchTerm('');
        setSelectedGenre('');
    };

    return (
        <motion.div 
            className="search-filter"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
        >
            <div className="filter-panel">
                <div className="filter-group">
                    <label className="filter-label">SEARCH TRACKS</label>
                    <div className="input-wrapper">
                        <input
                            type="text"
                            className="search-input"
                            placeholder="Enter track name or artist..."
                            value={searchTerm}
                            onChange={handleSearchChange}
                        />
                        <div className="input-border"></div>
                    </div>
                </div>

                <div className="filter-group">
                    <label className="filter-label">FILTER BY GENRE</label>
                    <div className="select-wrapper">
                        <select
                            className="genre-select"
                            value={selectedGenre}
                            onChange={handleGenreChange}
                        >
                            <option value="">All Genres</option>
                            {genres.map((genre, index) => (
                                <option key={index} value={genre}>
                                    {genre}
                                </option>
                            ))}
                        </select>
                        <div className="select-border"></div>
                    </div>
                </div>

                {(searchTerm || selectedGenre) && (
                    <motion.button
                        className="clear-filters-btn"
                        onClick={clearFilters}
                        initial={{ opacity: 0, scale: 0.8 }}
                        animate={{ opacity: 1, scale: 1 }}
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                    >
                        CLEAR FILTERS
                    </motion.button>
                )}
            </div>
        </motion.div>
    );
};

export default SearchFilter;